import { useEffect, useRef, useState } from 'react';

import { createPortal } from 'react-dom';

import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './RolloverTooltip.module.scss';

const RolloverTooltip = ({ children, tooltip, type = 'default' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const containerRef = useRef(null);

  useEffect(() => {
    if (isVisible && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + 4,
        left: rect.left,
      });
    }
  }, [isVisible]);

  return (
    <div
      ref={containerRef}
      className={styles.tooltipContainer}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}>
      {children}
      {isVisible &&
        tooltip &&
        createPortal(
          <div
            className={cn(styles.tooltipOverlay, styles[`tooltipOverlay--${type}`])}
            style={{
              position: 'fixed',
              top: tooltipPosition.top,
              left: tooltipPosition.left,
              zIndex: 9999,
            }}>
            {tooltip}
          </div>,
          document.body,
        )}
    </div>
  );
};

RolloverTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.node,
};

export default RolloverTooltip;
